<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Users"
              icon="fas fa-users">
          </card-section-header>
          <div class="link-page-group">
            <a [routerLink]="['/', routeRole, 'invite-users']">
              <i class="fas fa-envelope"></i>
              Invite Users
            </a>

            <a *ngIf="routeRole !== 'support'" [routerLink]="['/', routeRole, 'support-users']">
              <i class="fas fa-headset"></i>
              Support Users
            </a>

            <a [routerLink]="['/', routeRole, 'site-owners']">
              <i class="fas fa-user-tie"></i>
              Site Owners
            </a>

            <a [routerLink]="['/', routeRole, 'contractor-managers']">
              <i class="fas fa-industry"></i>
              Contractor Managers
            </a>
            <a [routerLink]="['/', routeRole, 'user-search']">
              <i class="fa-solid fa-magnifying-glass"></i>
              User Search
            </a>
            <a [routerLink]="['/', routeRole, 'send-email']">
              <i class="fa-solid fa-envelope"></i>
              Send Email
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
